export default __webpack_public_path__ + "static/media/Search-Users-GitHub-REST-API-gif.595cf507.gif";